  
    import { Club } from '@/models';
    import { mapGetters, mapActions } from 'vuex';   
    import { Player } from "@/models/player";
    import $ from 'jquery';
    import ClubAdminRolesEnum from '@/utils/enum/club-admin-roles-enum'; 
    import Cookies from "js-cookie";
    import Vue from 'vue';
       
    export default Vue.extend({
        name: 'DashboardLayout',
        data() {
            return {
                isSideMenuCollapsed: false,
                agentAdminCode: ClubAdminRolesEnum.AGENT
            }
        },
        computed: {
            ...mapGetters({                
                isInClubRole: 'currentPlayer/isInClubRole',
                isCoachOfClub: 'currentPlayer/isCoachOfClub',
                currentPlayer: 'currentPlayer/currentPlayer',     
                dashboardActiveMenu: 'dashboard/dashboardActiveMenu',
                dashboardClub: 'dashboard/dashboardClub'
            }),
            currentUserFullName(): string {
                return (this.currentPlayer as Player)?.full_name;    
            },
            showClubDashboard(): boolean {
                if (this.dashboardClub != null) return true;
                return false;
            },
            // access and permissions
            // for admins AND for club coaches
            accessMembers(): boolean  {
                return (this.isInClubRole(this.dashboardClub.id, ClubAdminRolesEnum.AGENT) 
                     || this.isInClubRole(this.dashboardClub.id, ClubAdminRolesEnum.MEMBERSHIP_FEES));
            },
            accessMatcha(): boolean  {
                return (this.isInClubRole(this.dashboardClub.id, ClubAdminRolesEnum.AGENT) 
                     || this.isInClubRole(this.dashboardClub.id, ClubAdminRolesEnum.MATCHA));
            },
            accessCourtBookings(): boolean  {
                return (this.isInClubRole(this.dashboardClub.id, ClubAdminRolesEnum.AGENT) 
                     || this.isInClubRole(this.dashboardClub.id, ClubAdminRolesEnum.COURT_BOOKINGS)
                     || this.isCoachOfClub(this.dashboardClub.id));
            },
            accessCourtBookingsConfiguration(): boolean  {
                return (this.isInClubRole(this.dashboardClub.id, ClubAdminRolesEnum.AGENT) 
                     || this.isInClubRole(this.dashboardClub.id, ClubAdminRolesEnum.COURT_BOOKINGS));
            },
            accessInsights(): boolean  {
                return (this.isInClubRole(this.dashboardClub.id, ClubAdminRolesEnum.AGENT) 
                     || this.isInClubRole(this.dashboardClub.id, ClubAdminRolesEnum.MEMBERSHIP_FEES) 
                     || this.isInClubRole(this.dashboardClub.id, ClubAdminRolesEnum.COURT_BOOKINGS));
            },
            accessClinics(): boolean  {
                return (this.isInClubRole(this.dashboardClub.id, ClubAdminRolesEnum.AGENT) 
                     || this.isInClubRole(this.dashboardClub.id, ClubAdminRolesEnum.COURT_BOOKINGS));
            },
            accessNewslettersAndMessages(): boolean  {
                return (this.isInClubRole(this.dashboardClub.id, ClubAdminRolesEnum.AGENT) 
                     || this.isInClubRole(this.dashboardClub.id, ClubAdminRolesEnum.COMMUNCIATIONS));
            },
            accessPayments(): boolean  {
                return (this.isInClubRole(this.dashboardClub.id, ClubAdminRolesEnum.AGENT) 
                     || this.isInClubRole(this.dashboardClub.id, ClubAdminRolesEnum.MEMBERSHIP_FEES) 
                     || this.isInClubRole(this.dashboardClub.id, ClubAdminRolesEnum.COURT_BOOKINGS));
            },
            accessPointOfSale(): boolean {
                return (this.isInClubRole(this.dashboardClub.id, ClubAdminRolesEnum.AGENT) 
                     || this.isInClubRole(this.dashboardClub.id, ClubAdminRolesEnum.POINT_OF_SALE));
            },
            accessClubSettings(): boolean {
                // include all the admin roles here because coaches are not permitted
                return (this.isInClubRole(this.dashboardClub.id, ClubAdminRolesEnum.AGENT) 
                     || this.isInClubRole(this.dashboardClub.id, ClubAdminRolesEnum.COURT_BOOKINGS)
                     || this.isInClubRole(this.dashboardClub.id, ClubAdminRolesEnum.MATCHA)
                     || this.isInClubRole(this.dashboardClub.id, ClubAdminRolesEnum.MEMBERSHIP_FEES)
                     || this.isInClubRole(this.dashboardClub.id, ClubAdminRolesEnum.COMMUNCIATIONS)
                     || this.isInClubRole(this.dashboardClub.id, ClubAdminRolesEnum.POINT_OF_SALE));
            }
        },
        methods: {
            logout() {
                this.setDashboardActiveMenu(null);
                this.setDashboardClub(null);
                Cookies.remove("authtoken");
                localStorage.removeItem("CurrentPlayer");
                localStorage.removeItem("dashboardActiveMenu");
                window.location.href = "/";
            },
            getClubDashboardSectionURL(sectionName: string, club: Club): string {
                if (club == null) return '/clubs/';
                return `/clubs/dashboard/${sectionName}/?clubId=${club?.id}`;
            },
            dashboardMenuClick(identifier: string) {
                this.setDashboardActiveMenu(identifier);
            },
            removeSelectedDashboardMenu() {
                this.setDashboardActiveMenu(null);
            },
            toggleSideMenu(collapse: boolean) {
                // toggle the display of the side navigation menu
                this.isSideMenuCollapsed = collapse;
            },
            gotoHrefLink(link: string) {
                try {
                    // attempt to open the menu link
                    $(`a[href="#` + link + `"]`)[0].click();
                }
                catch(err) {
                    // if the link cannot be found, it's more tha likely the feature is not includes in their subscription
                    // eslint-disable-next-line
                    console.log('Str8 Sets: The link is inactive, please check if your subscription contains this feature.')
                }                
            },
            ...mapActions({
                setDashboardActiveMenu: 'dashboard/setDashboardActiveMenu',
                setDashboardClub: 'dashboard/setDashboardClubAction'
            })
        },
        mounted() {
            // the clubs view is shown by default when the user logs in
            // check if another selection has not already been set, if found use that instead
            if (this.dashboardActiveMenu == null) {
                // dashboard is opened for the first time OR page reload
                // try to find the menu item in local storage
                const actMenu = localStorage.getItem('dashboardActiveMenu');
                if (actMenu && actMenu.length > 0) {
                    this.dashboardMenuClick(actMenu);
                }
                else this.dashboardMenuClick('clubs');
            }
            else this.dashboardMenuClick('clubs');
        }
    });
